import React, { useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import LS from '../styles/layoutStyled';
import CS from '../styles/componentStyled';
import styled from 'styled-components';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  passwordChangeStateRecoil,
  myInforChangeStateRecoil,
} from '../atom/ModalAtom';
import Header1 from '../component/Header1';
import ConfirmModal from '../modal/ConfirmModal';
import InputModal from '../modal/InputModal';
import PasswordChange from '../modal/input/PasswordChange';
import MyInforChange from '../modal/input/MyInforChange';
import { MyInforDto } from '../model/user.dto';
import { userIdState } from '../atom/TokenAtom';
import { authAPI } from '../api/axiosIndex';

const MyInfor = () => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const [userId, setUserId] = useRecoilState(userIdState);

  const navigate = useNavigate();

  const [logoutConfirmState, setLogoutConfirmState] = useState(false);
  const [myInfors, setMyInfors] = useState<MyInforDto | null>(null);

  const [passwordChangeState, setPasswordChangeState] = useRecoilState(
    passwordChangeStateRecoil,
  );
  const [myInforChangeState, setMyInforChangeState] = useRecoilState(
    myInforChangeStateRecoil,
  );

  const fetchMyInfors = async () => {
    try {
      const response = await authAPI.getMyInfor();
      setMyInfors(response.data);
    } catch (err: any) {
      console.log(err);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate('/login');
  };

  const handleListUpdate = () => {
    fetchMyInfors();
  };

  useEffect(() => {
    fetchMyInfors();
  }, []);

  return (
    <>
      <Header1 title="내 정보" />
      <LS.MainCntLayout>
        <Box>
          <li>
            <h1>아이디</h1>
            <div className="text-box">
              <p>{myInfors?.passid}</p>
            </div>
          </li>
          <li>
            <h1>휴대폰 번호</h1>
            <div className="text-box">
              <p>{myInfors?.phone}</p>
            </div>
          </li>
          <li>
            <h1>비밀번호 변경</h1>
            <div className="text-box">
              <button
                type="button"
                onClick={() => setPasswordChangeState(true)}
              >
                변경
              </button>
            </div>
          </li>
          <li>
            <h1>번호</h1>
            <div className="text-box">
              <p>
                {myInfors?.userNumber === '차량번호'
                  ? ''
                  : myInfors?.userNumber}
              </p>
              <button type="button" onClick={() => setMyInforChangeState(true)}>
                변경
              </button>
            </div>
          </li>
          <li>
            <h1>기타사항</h1>
            <div className="text-box">
              <p>
                {myInfors?.otherText === '회사번호' ? '' : myInfors?.otherText}
              </p>
              <button type="button" onClick={() => setMyInforChangeState(true)}>
                변경
              </button>
            </div>
          </li>
          <li>
            <h1>닉네임</h1>
            <div className="text-box">
              <p>{myInfors?.nickname === '닉네임' ? '' : myInfors?.nickname}</p>
              <button type="button" onClick={() => setMyInforChangeState(true)}>
                변경
              </button>
            </div>
          </li>
          <li className="btn-box">
            <button onClick={() => setLogoutConfirmState(true)}>
              로그아웃
            </button>
          </li>
        </Box>
      </LS.MainCntLayout>

      {logoutConfirmState && (
        <ConfirmModal
          text="정말 로그아웃 하시겠습니까?"
          onCancel={() => setLogoutConfirmState(false)}
          onConfirm={handleLogout}
        />
      )}

      {passwordChangeState && <PasswordChange />}

      {myInforChangeState && (
        <MyInforChange myInfors={myInfors} onListUpdate={handleListUpdate} />
      )}
    </>
  );
};

export default MyInfor;

export const Box = styled.ul`
  width: 100%;
  box-sizing: border-box;
  padding: 10px 0;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: ${(props) => props.theme.bsType1};

  > li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 16px 24px;
    &:not(:last-child) {
      border-bottom: 1px solid #f5f5f5;
    }
    &.btn-box {
      justify-content: center;
      padding: 8px 0;

      button {
        box-sizing: border-box;
        width: 100%;
        padding: 16px 0;
        font-size: 15px;
        color: #d33c3c;
      }
    }

    h1 {
      font-size: 15px;
      font-weight: 600;
      color: #333;
    }

    .text-box {
      display: flex;
      align-items: center;
      gap: 6px;

      p {
        font-size: 15px;
        color: #666;
      }

      button {
        font-size: 14px;
        color: ${(props) => props.theme.mainColor1};
      }
    }

    .log-btn {
      font-size: 14px;
      text-align: center;
    }
  }
`;
